import client from "@/lib/api";
import { useNavigate } from "@/lib/useNav";
import { NoticeCard } from "@/components/notices/NoticeCard";
import { useBlockData, BlockEmpty } from "@/components/dashboard/useBlockData";

export function NoticeboardBlock({ block }) {
  const navigate = useNavigate();
  const limit = block.settings?.limit || 5;
  const [rows] = useBlockData(() => client.get("/notices", { params: { limit } }).then((r) => r.data), [limit], 60000);
  if (!rows) return null;
  if (!rows.length) return <BlockEmpty>No notices</BlockEmpty>;
  return (
    <div className="space-y-2">
      {rows.map((n) => <NoticeCard key={n.id} n={n} compact />)}
      <button onClick={() => navigate("/noticeboard")} className="w-full rounded-lg py-1.5 text-xs font-semibold text-sky-600 hover:bg-sky-50" data-testid={`block-${block.id}-notices-view-all`}>View all notices</button>
    </div>
  );
}
